"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const User_dto_1 = require("./users/User.dto");
const Venue_dto_1 = require("./Venue.dto");
class ConversationDto {
  constructor() {
    this.unreadCount = 0;
  }
}
exports.ConversationDto = ConversationDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ConversationDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ConversationDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", User_dto_1.UserDto)], ConversationDto.prototype, "fromUser", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", User_dto_1.UserDto)], ConversationDto.prototype, "toUser", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", User_dto_1.UserDto)], ConversationDto.prototype, "otherUser", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], ConversationDto.prototype, "venueConnectedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ConversationDto.prototype, "unreadCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], ConversationDto.prototype, "messages", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ConversationDto.prototype, "duration", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ConversationDto.prototype, "createdAt", void 0);
//# sourceMappingURL=Conversation.dto.js.map